import React from "react";

const AIAnalysis = ({ analysisData, complianceScore }) => {
  return (
    <div className="space-y-4">
      {/* Compliance Score Card */}
      <div className="bg-[#BB42AE1F] border border-[#F5D0F0] rounded-xl px-3 py-1 mt-2">
        <div className="flex items-center gap-4">
          <div className="w-1.5 h-11 bg-[#C95EBE] rounded-full"></div>
          <div>
            <div className="text-[20px] font-bold text-[#BB42AE] font-outfit">
              {complianceScore}/100
            </div>
            <div className="text-[#18101C] font-outfit text-sm font-medium">
              Compliance Score
            </div>
          </div>
        </div>
      </div>

      {/* Summary */}
      {analysisData.summary && (
        <div className="space-y-2">
          <h3 className="font-outfit !font-semibold text-[#171717] text-[14px]">
            Summary
          </h3>
          <p className="!text-[#18101C] text-sm leading-relaxed font-normal font-outfit">
            {analysisData.summary}
          </p>
        </div>
      )}

      {/* Strengths */}
      {analysisData.strengths.length > 0 && (
        <div className="space-y-3">
          <span className="inline-block bg-[#34C75933] !text-[#007C1F] px-3 py-1 rounded-full text-[14px] font-semibold font-outfit">
            Strengths
          </span>
          <ul className="space-y-3">
            {analysisData.strengths.map((strength, index) => (
              <li
                key={index}
                className="flex items-start gap-2.5 text-sm font-normal !text-[#18101C] font-outfit"
              >
                <svg
                  className="w-5 h-5 text-[#34C759] shrink-0 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="leading-snug">{strength}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Deviations */}
      {analysisData.deviations.length > 0 && (
        <div className="space-y-3">
          <span className="inline-block bg-[#FFCC0033] text-[#B28F00] px-3 py-1 rounded-full text-[14px] font-semibold font-outfit">
            Deviations
          </span>
          <ul className="space-y-3">
            {analysisData.deviations.map((deviation, index) => (
              <li
                key={index}
                className="flex items-start gap-2.5 text-sm font-normal !text-[#18101C] font-outfit"
              >
                <span className="pt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                  >
                    <path
                      d="M0.674162 12C0.549123 12 0.435451 11.9694 0.333146 11.9083C0.230841 11.8472 0.151271 11.7667 0.0944351 11.6667C0.0375992 11.5667 0.00633939 11.4583 0.000655799 11.3417C-0.00502779 11.225 0.026232 11.1111 0.0944351 11L6.40322 0.333333C6.47143 0.222222 6.55952 0.138889 6.66751 0.0833333C6.7755 0.0277778 6.88633 0 7 0C7.11367 0 7.2245 0.0277778 7.33249 0.0833333C7.44048 0.138889 7.52857 0.222222 7.59678 0.333333L13.9056 11C13.9738 11.1111 14.005 11.225 13.9993 11.3417C13.9937 11.4583 13.9624 11.5667 13.9056 11.6667C13.8487 11.7667 13.7692 11.8472 13.6669 11.9083C13.5646 11.9694 13.4509 12 13.3258 12H0.674162ZM1.85067 10.6667H12.1493L7 2L1.85067 10.6667ZM7 10C7.19324 10 7.35523 9.93611 7.48595 9.80833C7.61667 9.68056 7.68203 9.52222 7.68203 9.33333C7.68203 9.14444 7.61667 8.98611 7.48595 8.85833C7.35523 8.73056 7.19324 8.66667 7 8.66667C6.80676 8.66667 6.64478 8.73056 6.51405 8.85833C6.38333 8.98611 6.31797 9.14444 6.31797 9.33333C6.31797 9.52222 6.38333 9.68056 6.51405 9.80833C6.64478 9.93611 6.80676 10 7 10ZM7 8C7.19324 8 7.35523 7.93611 7.48595 7.80833C7.61667 7.68056 7.68203 7.52222 7.68203 7.33333V5.33333C7.68203 5.14444 7.61667 4.98611 7.48595 4.85833C7.35523 4.73056 7.19324 4.66667 7 4.66667C6.80676 4.66667 6.64478 4.73056 6.51405 4.85833C6.38333 4.98611 6.31797 5.14444 6.31797 5.33333V7.33333C6.31797 7.52222 6.38333 7.68056 6.51405 7.80833C6.64478 7.93611 6.80676 8 7 8Z"
                      fill="#B28F00"
                    />
                  </svg>
                </span>
                <span className="leading-snug">{deviation}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Recommendations */}
      {analysisData.recommendations.length > 0 && (
        <div className="space-y-3">
          <span className="inline-block bg-[#007AFF26] text-[#007AFF] px-3 py-1 rounded-full text-[14px] font-semibold font-outfit">
            Recommendations
          </span>
          <ul className="space-y-3">
            {analysisData.recommendations.map((recommendation, index) => (
              <li
                key={index}
                className="flex items-start gap-2.5 text-sm font-normal !text-[#18101C] font-outfit"
              >
                <svg
                  className="w-5 h-5 text-[#2563EB] shrink-0 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
                <span className="leading-snug">{recommendation}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AIAnalysis;
